import { Component, OnInit, ViewChild, Input, SimpleChanges, ChangeDetectionStrategy, Inject, ElementRef } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { RequestHistory, RequestBuildingUnitView, CompanyBuildingUnitView, FMLayout } from '@app/core';
import * as fromcoreStore from '@app/core/store';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs/Subscription';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-get-value-form',
  templateUrl: './get-value-form.component.html',
  styleUrls: ['./get-value-form.component.scss'],
})
export class SharedGetValueFormComponent implements OnInit  {
  
  _fieldValue: string;
  _headerValue: string;
  _hasNotes: boolean = false;
  form: FormGroup;
  @ViewChild('myId') myId: ElementRef;
  constructor( @Inject(MAT_DIALOG_DATA) public data: any
    , public dialogRef: MatDialogRef<SharedGetValueFormComponent>,
    private formBuilder: FormBuilder
  ) {
    this._hasNotes = data._hasNotes
 //   console.log(data._hasNotes);
  }

  ngOnInit() {


    this.form = this.formBuilder.group({
      formValue: [''],
      formNotes: [''],
    })

  
    if (this._hasNotes) {

      this.myId.nativeElement.style.display = 'Block';


      this.form.get('formNotes').setValidators([Validators.required]);
      this.form.get('formNotes').updateValueAndValidity();
    }
    else {
     
      this.myId.nativeElement.style.display = 'none';

      this.form.get('formNotes').clearValidators();
      this.form.get('formNotes').updateValueAndValidity();

    }
  }
  ngOnChanges() {
   

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/get-value-form/get-value-form.component.ts